import React, { useEffect, useState, useCallback } from 'react'
import Modal from '@mui/material/Modal'
import { Box, DialogActions, DialogContent, useMediaQuery, useTheme } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Typography from '@mui/material/Typography'
import { useForm } from 'react-hook-form'
import { Input } from 'Components/Input'
import Button from '@mui/material/Button'
import ComboBox from 'Components/ComboBox'
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import { makeGetRequest, makePostRequest } from 'utils/api'
import urls from 'utils/urls'
import { toast } from 'react-toastify'

const mstyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: 2,
  bgcolor: 'background.paper',
  boxShadow: 24,
}

export default function CreateTask({ setCreateTache, title }) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [category, setCategory] = useState([])
  const handleModelClose = () => {
    setCreateTache(false)
    reset()
  }
  const priorite = [
    { label: 'Important et urgent', id: 1 },
    { label: 'Important et non urgent', id: 2 },
    { label: 'Non-important et urgent', id: 3 },
    { label: 'Non-important et non-urgent', id: 4 },
  ]
  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      Nom: '',
      Descriptions: '',
    },
  })

  useEffect(() => {
    fetchCategory()
  }, [])

  const fetchCategory = async () => {
    const url = '/api/time/get-category-dd'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.name}`, id: v.id })
      })
      setCategory([...filterTypes])
    }
  }

  const onSubmit = async (data) => {
    let payload = {}
    payload = {
      ...data,
      Priorite: data.Priorite.label,
      Categorie: data.Categorie.id,
    }

    const response = await makePostRequest(urls.taskOperations, payload, {}, true)
    if (response.status === 201) {
      toast(`Tache for ${title} successfully created.`, {
        position: 'top-right',
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        theme: 'dark',
        pauseOnFocusLoss: false,
      })
      handleModelClose()
    }
  }

  return (
    <>
      <Modal
        open={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflowY: 'scroll', '.tachmo': { width: isMobile ? '90%' : '500px' } }}
      >
        <Box className="tachmo" sx={mstyle}>
          <Box>
            <Box
              sx={{ textAlign: 'end', padding: '5px 10px', position: 'relative', zIndex: '999' }}
            >
              <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleModelClose} />
            </Box>
            <Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '-30px',
                }}
              >
                <Box sx={{ width: '-webkit-fill-available' }}>
                  <Typography
                    id="modal-modal-title"
                    sx={{ color: 'black !important' }}
                    variant="h6"
                    component="h3"
                  >
                    Nouvelle tâche
                  </Typography>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent>
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          required: true,
                          size: 'small',
                          type: 'text',
                        }}
                        rules={{ required: true }}
                        name="Nom"
                        label="Nom"
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          required: false,
                          size: 'small',
                          type: 'text',
                        }}
                        rows={4}
                        multiline
                        rules={{ required: false }}
                        name="Descriptions"
                        label="Description"
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          // required: true,
                          size: 'small',
                          type: 'date',
                        }}
                        // rules={{ required: true }}
                        name="DateLimite"
                        label="Date Limite"
                        InputLabelProps={{ shrink: true }}
                      />

                      <ComboBox
                        handleAutoComplete={(e, j) => {
                          setValue('Priorite', j)
                        }}
                        label="Priorite"
                        data={priorite}
                        name="Priorite"
                        required={true}
                      />
                      <ComboBox
                        handleAutoComplete={(e, j) => {
                          setValue('Categorie', j)
                        }}
                        label="Catégorie"
                        data={category}
                        name="Categorie"
                        required={true}
                      />

                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          required: false,
                          size: 'small',
                          type: 'number',
                        }}
                        rules={{ required: false }}
                        name="Couts"
                        label="Coûts"
                      />
                    </DialogContent>
                    <DialogActions>
                      <Button sx={{ marginLeft: 'auto !important' }} type="submit">
                        Valider
                      </Button>
                    </DialogActions>
                  </form>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  )
}
